
import React, { useState } from 'react';
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import UIDatePicker from "components/datepicker";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import codeDataStore from "common/codedata/store/CodeDataStore";
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import StringUtil from "../../../../utils/StringUtil";
import TbComFile from "../../../../domain/main/com/file/TbComFile";
import UITextArea from "components/atoms/textarea/UITextArea";
import UIUtils from "utils/UIUtils";
import UISelect from 'components/selectbox/UISelect';
import message from "common/message/source/MessageSource";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";

function ContentsContainer() {
	const modaladm2138 = useToggleState({});
	const location = useLocation();
  	const receivedData = (location.state as any)?.data;
	let redeReqAmtListPopData = {};   //환수기업 내역등록 팝업

	const [tbCfmsPayReqData, setTbCfmsPayReqData] = React.useState<any[]>([]); 
	const [redeReqAmtListPopSaveData, setRedeReqAmtListPopSaveData] = React.useState<any[]>([]); 
	const [tempRedeReqAmtListPopSaveData, setTempRedeReqAmtListPopSaveData] = React.useState<any[]>([]); 
	const [modaladm2135Open, setModaladm2135Open] = useState(false); //집행과제선택 팝업오픈여부
	const [modaladm2138Open, setModaladm2138Open] = useState(false); //환수기업조회 팝업오픈여부
	

	const history = useHistory();	
	const [totalTskRowCnt,setTotalRedeTskCnt] = useState(0);
	const [totalReqAmtListCnt,setTotalRedeReqAmtListCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(1); //기본 row count
	const [fileInfoUploadList, setFileInfoUploadList] = React.useState<any[]>([]);  //파일업로드 리스트

	const [redeDetail, setRedeDetail] = useState({});
	const [payDetail, setPayDetail] = useState({});
	const [tskDetail, setTskDetail] = useState({});
	const [memberDetail, setMemberDetail] = useState({});

	//파일정보 선언 
	const [fileId, setFildId] = useState('');
	const [fileValue, setFileValue] = useState(new TbComFile());
	const [loadFinish,setLoadFinish] = useState(false);
	const deferredFileValue = React.useDeferredValue(fileValue);

    let totalCnt:number = 0;
	let defaultRowCnt = 20;
	let totalRedeTskCnt:number = 0;
	let totalRedeReqAmtListCnt:number = 0;
	const [redeCnt,setRedeCnt] = useState('');
	const [payAmtSum,setPayAmtSum] = useState('');
	const [redeAmtSum,setRedeAmtSum] = useState('');

	//항목값들
	//과제정보 
	const [bizCd,setBizCd] = useState('');
	const [tskNm,setTskNm] = useState('');
	const [tskReqNo,setTskReqNo] = useState('');
	const [payReqNo,setPayReqNo] = useState('');
	const [tskReqModiSeq,setTskReqModiSeq] = useState('');
    
	//환수정보
	const [redeReqNo,setRedeReqNo] = useState('');  // 환수신청번호
	const [redeReqDate,setRedeReqDate] = useState(new Date());  // 환수신청일
	const [redeReason,setRedeReason] = useState('');  // 환수사유
	const [redeCorpCnt,setRedeCorpCnt] = useState(0);  // 환수기업수
	const [redeAmt,setRedeAmt] = useState(0);  // 환수금액
	const [regUserId,setRegUserId] = useState('');  // 환수사유

	//환수기업정보 
	const [suppBizNo,setSuppBizNo] = useState('');  // 사업자등록번호
	const [suppCorpNm,setSuppCorpNm] = useState('');  // 지원기업명
	const [suppCeoNm,setSuppCeoNm] = useState('');  // 대표자명
	const [suppPayAmt,setSuppPayAmt] = useState('');  // 지급금액
	const [suppRedeAmt,setSuppRedeAmt] = useState('');  // 환수금액

	
    //기업정보
	const [corpNm,setCorpNm] = useState('');  // 기업명
	const [bizNo,setBizNo] = useState('');  // 사업자번호
	const [corpRegNo,setCorpRegNo] = useState(''); //법인등록번호
	const [redeReqUserid,setRedeReqUserid] = useState('');  // 담당자ID
	const [redeReqUserNm,setRedeReqUserNm] = useState('');  // 담당자명
	const [posiNm,setPosiNm] = useState('');  // 직급
	const [deptNm,setDeptNm] = useState('');  // 부서명
	const [emailAdres,setEmailAdres] = useState('');  // 이메일
	const [ofcTelNo,setOfcTelNo] = useState('');  // 전화번호
	
    // 폼체크 여부 
	const [formCheck,setFormCheck] = useState(false);  

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init': {
			"RedeReqAmtList": {  //환수기업조회 
				"Cfg": {
				    "SearchMode": 3,
					//"PageLength": 20,
					"AutoRowHeight": 1,
					"InfoRowConfig": "0",
					"Alternate":"0",
					"HeaderMerge": 6,
					"HeaderCheck": 1,
					"HeaderCheckMode": 1,
					"CanSort": 0,                 // 소팅옵션 off
					"ShowFilter": 1,             // 필터행 표시
					"dataMerge":1,
				},
				"Cols": [
					{"Header": ["환수기업 내역","지원기업"],"Type": "Text","Name": "SUPP_CORP_NM","RelWidth": 1.5,"Align": "Center" ,"CanEdit": 0},
					{"Header": ["환수기업 내역","사업자등록번호"],"Type": "Text","Name": "SUPP_BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": 0},
					{"Header": ["환수기업 내역","대표자명"],"Type": "Text","Name": "SUPP_CEO_NM","RelWidth": 2,"Align": "Center","CanEdit": 0},
					{"Header": ["환수기업 내역","지원금액(원)"],"Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Right","CanEdit": 0},
					{"Header": ["환수기업 내역",{"Value": "환수금액(원)" ,"Color": "#FFDFDF"}],"Type": "Int","Name": "REDE_AMT","RelWidth": 2,"Align": "Right","CanEdit": 1},
					//숨김컬럼
					{"Header": "REDE_REQ_NO","Type": "Text","Name": "REDE_REQ_NO","RelWidth": 0,Visible : 0},
					{"Header": "SUPP_TP_CD","Type": "Text",	"Name": "SUPP_TP_CD","RelWidth": 0,	Visible : 0},
					{"Header": "PAY_REQ_NO","Type": "Text",	"Name": "PAY_REQ_NO","RelWidth": 0,	Visible : 0},
					{"Header": "ACCYY",	"Type": "Text",	"Name": "ACCYY","RelWidth": 0,Visible : 0},
					{"Header": "ANCT_A_CD","Type": "Text",	"Name": "ANCT_A_CD","RelWidth": 0,Visible : 0},
					{"Header": "ANCT_B_CD","Type": "Text",	"Name": "ANCT_B_CD","RelWidth": 0,Visible : 0},
					{"Header": "ANCT_C_CD","Type": "Text",	"Name": "ANCT_C_CD","RelWidth": 0,Visible : 0},
					{"Header": "OUTGOING","Type": "Text",	"Name": "OUTGOING",	"RelWidth": 0,Visible : 0},
					{"Header": "PAY_SEQ","Type": "Text",	"Name": "PAY_SEQ",	"RelWidth": 0,Visible : 0},
					{"Header": "REDE_REQ_SUMMARY","Type": "Text",	"Name": "REDE_REQ_SUMMARY",	"RelWidth": 0,Visible : 0},

				
				]
				
			},
		},

		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
			

				var sheet = evtParam.sheet;
			    if(sheet.id === "RedeReqAmtList"){
					
					//@ts-ignore
					sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_CEO_NM", sheet.getRowById("Filter"), "SUPP_CEO_NM");
					//@ts-ignore
					sheet.setMergeRange( sheet.getRowById("HR1"), "PAY_AMT", sheet.getRowById("Filter"), "PAY_AMT");
					//@ts-ignore
					sheet.setMergeRange( sheet.getRowById("HR1"), "REDE_AMT", sheet.getRowById("Filter"), "REDE_AMT");
					
					getRedeReqAmtList('init');
					
				}

			},
            //데이터 로딩 후 이벤트 처리
			onDataLoad:function (evtParam) {
				// 시트에 들어간 데이터가 파싱되어 로드된 후에 발생합니다. (데이터는 파싱되었으나 화면에 반영되는 렌더링 전입니다.)
				var sheet = evtParam.sheet;
				if(sheet.id === "RedeReqAmtList"){ //환수기업내역 

					//@ts-ignore
					var redeReqAmtListRows = sheet.getDataRows(); //RedeReqAmtList 시트 전체 데이터 조회
					
					let payAmtSum = 0;
					let redeAmtSum = 0;
					for(var i=0; i<redeReqAmtListRows.length; i++){
						payAmtSum += redeReqAmtListRows[i].PAY_AMT;
						redeAmtSum += redeReqAmtListRows[i].REDE_AMT;
					}

					setPayAmtSum(String(payAmtSum));
					setRedeAmtSum(String(redeAmtSum));
					
					var saveJson = sheet.getSaveJson({saveMode:1});

					//console.log("getSaveJson "+ JSON.stringify(saveJson));
					setTempRedeReqAmtListPopSaveData(saveJson); 
				}
			},
			onStartEdit:function(evtParam){
				var sheet = evtParam.sheet;
				if(sheet.id === "RedeReqAmtList"){   //환수금액 입력시 
					if(evtParam.col === "REDE_AMT" ){
						//@ts-ignore
						$("#modaladm2138Save").attr("disabled", true);
					}
				}
			},
			onEndEdit:function(evtParam){
				var sheet = evtParam.sheet;
				if(sheet.id === "RedeReqAmtList"){   //환수금액 입력시 
					if(evtParam.col === "REDE_AMT" ){
						//@ts-ignore
						$("#modaladm2138Save").attr("disabled", false);
					}
				}
			},
			
			// 셀값 수정후 발생합니다.
			onAfterChange:function (evtParam) {
				var sheet = evtParam.sheet;
				if(sheet.id === "RedeReqAmtList"){   //환수금액 입력시 

					let redeAmtCnt = 0;
					let redeAmtSum = 0;
					let payAmtSum = 0;
					if(evtParam.col === "REDE_AMT" ){
						//@ts-ignore
						var redeReqAmtListRows = sheet.getDataRows(); //RedeReqAmtList 시트 전체 데이터 조회
						for(var i=0; i<redeReqAmtListRows.length; i++){
							payAmtSum += redeReqAmtListRows[i].PAY_AMT;

							if(Number(redeReqAmtListRows[i].REDE_AMT) > 0){
								redeAmtCnt = redeAmtCnt+1;
								sheet.setAttribute(sheet.getFocusedRow(), sheet.getFocusedCol() ,"Color" ,"#FFDFDF" ,1);
							}
							redeAmtSum += redeReqAmtListRows[i].REDE_AMT;
						}

						
						//합계금액 체크 (결합 #1037 환수 데이터 등록 - 지원금을 초과하더라도 등록이 가능하게 됨)
						if(redeAmtSum > payAmtSum){
							UIUtils.alert('지급급액를 초과할 수 없습니다.').then();
							sheet.setValue({row:evtParam.row, col:evtParam.col, val:"0", render:1});
							return;
						}
						
						setRedeCnt(String(redeAmtCnt))
						setRedeAmtSum(String(redeAmtSum));
						//redeReqAmtListPopData = sheet.getSaveJson
						var saveJson = sheet.getSaveJson({saveMode:1});

						console.log("getSaveJson "+ JSON.stringify(saveJson));
						setRedeReqAmtListPopSaveData(saveJson); 

						//@ts-ignore
						$("#modaladm2138Save").attr("disabled", false);
					}
				}
			},
			
			//시트 클릭시 이벤트 처리
			onAfterClick:function(evtParam){


			},
			
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				let sliceData = [];
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					sliceData = d.slice(0, defaultRowCnt);
					_data = JSON.stringify(sliceData, null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}
			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				if(sheet.id === "RedeTskList"){  
					//@ts-ignore
					var page = RedeTskList.getPageIndex(RedeTskList.getFocusedPage()) + 1;
					//@ts-ignore
					if (currentPage != -1 && currentPage != page) {
						makePageIndex(page, "tskList");
					}
				}else if(sheet.id === "RedeReqAmtList"){  
					//@ts-ignore
					var page = RedeReqAmtList.getPageIndex(RedeReqAmtList.getFocusedPage()) + 1;
					//@ts-ignore
					if (currentPage != -1 && currentPage != page) {
						makePageIndex(page, "reqAmtList");
					}
				}

			}
		},
		
		//시트객체 생성
		'createRedeReqAmtList':function () {
			var options3 = this.init.RedeReqAmtList;
			options3.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'RedeReqAmtList', // 생성할 시트의 id
				el: 'RedeReqAmtListDiv', // 시트를 생성할 Dom 객체 및 id
				options: options3, // 생성될 시트의 속성
				data: redeReqAmtListPopData // 생성될 시트의 정적데이터
			});

			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부  END

	//====== 그리드 데이터 가지고 오기  START
	

	//환수기업 내역조회
	async function getRedeReqAmtList(sAction:string) {
		if(payReqNo == "" || payReqNo == null){
			await UIUtils.alert("집행과제를 선택해주세요.");
			return;
		}

		//@ts-ignore
		if(redeReqAmtListPopSaveData.data != undefined ){
			//@ts-ignore
			let payReqNo1 = StringUtil.replaceAll(redeReqAmtListPopSaveData.data[0].PAY_REQ_NO, "-","",true );
			let payReqNo2 = StringUtil.replaceAll(payReqNo, "-","", true );
			//@ts-ignore
			if(payReqNo1 == payReqNo2){
				//@ts-ignore
				redeReqAmtListPopData = redeReqAmtListPopSaveData.data;
			}
			//데이터 처리
			ib.redeReqAmtListPopData = redeReqAmtListPopData;
				// @ts-ignore
			RedeReqAmtList.loadSearchData(redeReqAmtListPopData);  //data 로딩 처리
		}else{
			let param = {
				"PAY_REQ_NO" : payReqNo,
				"REDE_REQ_NO" : redeReqNo
			}
			//파라미터 전송
			const response:any = await CommonUtil.execute({
				url:'usr_2136_selectRedeReqAmtList',
				data: param
			})
	
			//전체데이터
			let result = response.LIST;
	
			//전체ROW개수
			totalRedeReqAmtListCnt = Object.keys(result).length;
			setTotalRedeReqAmtListCnt(Object.keys(result).length);
	
			//데이터 처리
			ib.redeReqAmtListPopData = result;
			// @ts-ignore
			RedeReqAmtList.loadSearchData(result);  //data 로딩 처리
		}
		
		// @ts-ignore
		RedeReqAmtList.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		// @ts-ignore
		//makePageIndex(RedeReqAmtList.getPageIndex( RedeReqAmtList.getFocusedPage()) + 1, "reqAmtList"); // 페이지 초기화

	}
	//====== 그리드 데이터 가지고 오기  END
	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number, divCd:string) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = 0; // 전체 조회 건수
			let page = 20;
			if(divCd =="reqAmtList"){
				// @ts-ignore
				if (document.getElementById('pageNaviRede').firstChild) {
					// @ts-ignore
					document.getElementById('pageNaviRede').removeChild(document.getElementById('pageNaviRede').firstChild);
				}
			   sr = totalRedeReqAmtListCnt;
			   // @ts-ignore
			   page = defaultRowCnt; // 레코드 수
			}
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
			let ul_sub = document.createElement('DIV');
			ul_sub.className ="group";
			li = document.createElement('Button');
			li.className = 'item first';
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			tt = document.createTextNode('<<');
			addEventHandler(li, 'click', pageMove, 1, divCd);
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub.appendChild(li)
			ul.appendChild(ul_sub);
			
			li = document.createElement('Button');
			li.className = 'item prev';
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			addEventHandler(li, 'click', pageMove, tp - 1, divCd);
			tt = document.createTextNode('<');
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub.appendChild(li)
			ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
			if (i <= lastpage) {
				li = document.createElement('Button');
				li.className ="item";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode(String(i));
				addEventHandler(li, 'click', pageMove, i, divCd);
				if (i === tp) {
				li.className ="item active";
				}
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub2.appendChild(li);
				ul.appendChild(ul_sub2);
			}
			}
	
			if (thispage < lastpage) {
			let ul_sub3 = document.createElement('DIV');
			ul_sub3.className ="group";	
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			li = document.createElement('Button');
			li.className = 'item next';
			tt = document.createTextNode('>');
			addEventHandler(li, 'click', pageMove, tp + 1 ,divCd);
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub3.appendChild(li);
			ul.appendChild(ul_sub3);
			
			li = document.createElement('Button');
			li.className = 'item last';
			tt = document.createTextNode('>>');
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			addEventHandler(li, 'click', pageMove, lastpage, divCd);
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub3.appendChild(li);
			ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			if(divCd =="reqAmtList"){
				// @ts-ignore
				document.getElementById('pageNaviRede').appendChild(ul);
			}
	
		} catch (ex) {
			// @ts-ignore
			console.log(ex.message);
		}
		}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number, divCd:string) {
		 if(divCd =="reqAmtList"){
			// @ts-ignore
			RedeReqAmtList.goToPageByIndex(cPage);
		 }
	
	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param, param2) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param ,param2); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param ,param2); });
		}
	}

	// 환수기업목록조회 모달 modal2138Open 오픈
	async function modal2138Open() {
		// @ts-ignore
		if(IBSheet.RedeReqAmtList !==undefined){
			// @ts-ignore
			IBSheet.RedeReqAmtList.dispose();
		}
		if(payReqNo == "" || payReqNo == null){
			await UIUtils.alert("집행과제를 선택해주세요.");
			return false;
		}
		setModaladm2138Open(true)
	}

	
	//환수기업 내역저장  모달 modaladm2138Close 닫기
	async function modaladm2138Save() {
		setRedeAmt(Number(redeAmtSum))
		setRedeCorpCnt(Number(redeCnt));

		// @ts-ignore
		if(IBSheet.RedeReqAmtList !==undefined){
			// @ts-ignore
			IBSheet.RedeReqAmtList.dispose();
		}
		setModaladm2138Open(false);
	}

	//환수기업목록조회 모달 modaladm2138Close 닫기
	async function modaladm2138Close() {
		// @ts-ignore
		if(IBSheet.RedeReqAmtList !==undefined){
			// @ts-ignore
			IBSheet.RedeReqAmtList.dispose();
		}
		setModaladm2138Open(false);
		setRedeReqAmtListPopSaveData(tempRedeReqAmtListPopSaveData);
	}

	//환수기업목록조회 모달 onAfterModaladm2138Open IBSheet오픈 
	async function onAfterModaladm2138Open() {
		// @ts-ignore
		if(IBSheet.RedeReqAmtList !==undefined){
			// @ts-ignore
			IBSheet.RedeReqAmtList.dispose();
		}
		ib.createRedeReqAmtList();
    }

	//---파일업로드 
	const [uploadId, setUploadId] = React.useState("");
	
	//파일업로드 
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
		//console.log("arrayNew : "+JSON.stringify(arrayNew));
		//console.log("arrayDel : "+JSON.stringify(arrayDel));

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		};

		

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"ADD"
			}

			fileInfos.push(fileInfo);
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				//STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				STRE_PATH:item.uploadPath,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			
		})

		//setFileInfoDeleteList(delFileInfos);
		setFileInfoUploadList(fileInfos);
	
		
    }

	//파이업로드
	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

	//취소시 상세화면으로 이동 
	const redeUpdateCancel = (e) =>{
		history.push({
			pathname: './usr_2137',  
			state: { data: receivedData }
		});
	}

	//목록으로 
	const goList = (e) =>{
		history.push({
			pathname: './usr_2133',  
			state: { data: receivedData }
		});
	}

	 /**
   * 담당자 정보 조회
   *
   * @param personId
   */
	async function readPerson(paramPersonId: string) {
		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'usr_2136_readPerson',
			data: {"PERSON_ID":paramPersonId}
		}).catch((err:any)=>{
			console.log("err",err);
		});
		
		if(response !=null){
			setCorpNm(response.CORP_NM);
			setCorpRegNo(response.CORP_REG_NO);
			setBizNo(response.BIZ_NO);  // 담당자ID
			setRedeReqUserid(response.PERSON_ID);  // 담당자ID
			setRedeReqUserNm(response.PERSON_NM); // 담당자명
			setPosiNm(response.POSI_NM); // 직급
			setDeptNm(response.DEPT_NM); // 부서명
			setEmailAdres(response.EMAIL_ADRES); // 이메일
			setOfcTelNo(response.OFC_TEL_NO);  // 전화번호
		}
	}

	//환수신청 저장 파일업로드 
	async function redeFormCheck() {
		if((payReqNo ==='' || payReqNo === null)){
			await UIUtils.alert("필수 입력이 완료되지 않았습니다.");
			return;
		}

		if((tskReqNo === '' || tskReqNo ===  null)){
			await UIUtils.alert("필수 입력이 완료되지 않았습니다.");
			return;
		}

		if((redeReqUserid === '' || redeReqUserid === null)){
			await UIUtils.alert("필수 입력이 완료되지 않았습니다.");
			return;
		}
		if((redeReason === '' || redeReason === null)){
			await UIUtils.alert("필수 입력이 완료되지 않았습니다.");
			return;
		}

		if(redeAmt === 0 || redeCorpCnt === 0){
			await UIUtils.alert("환수금액의 합계가 0원은 신청할 수 없습니다.");
			return;
		}
			
		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
			setFormCheck(true);

			//파일업로드 
			onFileUpload();
		}
	}

	//환수신청 내용 저장
	async function redeUpdate(sendParam:any) {
 		//
		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'usr_2138_redeUpdate',
			data: sendParam
		}).catch(err => {
			CommonUtil.showAxiosError(err);
			return;
		});

		let redeReqNo = response.REDE_REQ_NO;
		if(redeReqNo != null){
			UIUtils.alert(message.get("common.message.save.success", "저장되었습니다.")).then(() => {
				var vREDE_REQ_NO = redeReqNo;
				var vPAY_REQ_NO = payReqNo;
				var vTSK_REQ_NO = tskReqNo;
				var vTSK_REQ_MODI_SEQ = tskReqModiSeq;
						
				let dataToSend = {vREDE_REQ_NO, vPAY_REQ_NO, vTSK_REQ_NO, vTSK_REQ_MODI_SEQ};
				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
					pathname: './usr_2137',
					state: { data: dataToSend }
				});
			});
		}

	
	}

	//상세정보 값 가지고 오기
	function getInfo(name, type){
		if(type =='rede'){
			if(Object.keys(redeDetail).length != 0){
				return redeDetail[name];
			}else{
				return '';
			}
		}else if(type =='pay'){
			if(Object.keys(payDetail).length != 0){
				return payDetail[name];
			}else{
				return '';
			}
		}else if(type =='tsk'){
			if(Object.keys(tskDetail).length != 0){
				return tskDetail[name];
			}else{
				return '';
			}
		}else if(type =='user'){
			if(Object.keys(memberDetail).length != 0){
				return memberDetail[name];
			}else{
				return '';
			}
		}
		
	};

	//상세정보 가지고 오기 
	async function initCall(redeReqNo, payReqNo, tskReqNo,tskReqModiSeq){
		
		let param = {
			"REDE_REQ_NO": redeReqNo
			,"PAY_REQ_NO": payReqNo
			,"TSK_REQ_NO": tskReqNo
			,"TSK_REQ_MODI_SEQ": tskReqModiSeq
		};

		const response:any = await CommonUtil.execute({
			url:'usr_2137_redeDetail',
			data: param
		})

		const result = response;
		
		setRedeDetail(result.REDE_DETAIL);   //환수정보
		setPayDetail(result.PAY_DETAIL[0]);     //지급정보
		setTskDetail(result.TSK_DETAIL);     //과제정보
		setMemberDetail(result.PERSON_DETAIL);     //과제정보
		
		//환수정보 
		setRedeReqNo(result.REDE_DETAIL.REDE_REQ_NO);
		setRegUserId(result.REDE_DETAIL.REG_USERID);
		setFildId(result.REDE_DETAIL.FILE_ID);
		setTskNm(result.TSK_DETAIL.TSK_NM);   //과제명 
		setRedeReqDate(new Date(result.REDE_DETAIL.REDE_REQ_DATE)); //환수신청일자
		setRedeReason(result.REDE_DETAIL.REDE_REASON); //환수사유
		setRedeAmt(Number(result.REDE_DETAIL.REDE_AMT));  //환수금액
		setRedeCorpCnt(result.REDE_DETAIL.REDE_CORP_CNT); //환수신
		
		//기업정보 
		setCorpNm(result.PERSON_DETAIL.CORP_NM);  // 기업명
		setBizNo(result.PERSON_DETAIL.BIZ_NO);  // 사업자번호
		setCorpRegNo(result.PERSON_DETAIL.CORP_REG_NO); //법인등록번호
		setRedeReqUserid(result.PERSON_DETAIL.PERSON_ID);  // 담당자ID
	    setRedeReqUserNm(result.PERSON_DETAIL.PERSON_NM);  // 담당자명
	    setPosiNm(result.PERSON_DETAIL.POSI_NM);  // 직급
		setDeptNm(result.PERSON_DETAIL.DEPT_NM);  // 부서명
		setEmailAdres(result.PERSON_DETAIL.EMAIL_ADRES);  // 이메일
		setOfcTelNo(result.PERSON_DETAIL.OFC_TEL_NO);  // 전화번호

		let vfileInfoList = result.FILE_INFO_LIST;

		//해당 기업의 담당자 필요한 공통코드 로딩.
		codeDataStore.read("potal.personByBizNo,"+result.PERSON_DETAIL.BIZ_NO).then();
		
		console.log("usr_2138_redeDetail :: "+JSON.stringify(response));
	    

        //파일정보 있을경우
		//@ts-ignore
        if(vfileInfoList!= null){
			const tempFileValue = new TbComFile();
			vfileInfoList?.forEach((item, index) => {
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(item.DWLD_ID);
				fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(item.FILE_POLICY);
				fileDetail.setFileRpstr(item.FILE_RPSTR);
				fileDetail.setStrePath(item.STRE_PATH);
				fileDetail.setStreFileNm(item.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(item.FILE_EXTSN);
				fileDetail.setFileSize(Number(item.FILE_SIZE));
				fileDetail.setRegistDt(item.REGIST_DT);
				fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);

				tempFileValue.putTbComFileMapngDetailList(fileDetail);
			})
			setFileValue(tempFileValue);
		}

		setLoadFinish(true);

	};

	// 파일 업로드 성공여부 체크
	React.useEffect(() => {
		if(fileInfoUploadList && formCheck) {
			// 파일 업로드 성공
			let param ={
				"REDE_REQ_NO":redeReqNo,                   
				"BIZ_NO": bizNo
				,"REDE_REQ_DATE":DateUtil.toDateFormat(redeReqDate, "YYYYMMDDHHmmss")
				,"REDE_REQ_USERID":redeReqUserid
				,"REDE_AMT":redeAmt
				,"REDE_CORP_CNT":redeCorpCnt
				,"REDE_REASON":redeReason
				,"BANK_CD":getInfo('BANK_CD', 'rede')
				,"REDE_ACC_NO":getInfo('REDE_ACC_NO', 'rede')
				,"ACCT_NO_DES":getInfo('ACCT_NO_DES', 'rede')
				,"REDE_REQ_STS_CD" :getInfo('REDE_REQ_STS_CD', 'rede')
				,"SUPP_CONT_DIV_CD":getInfo('SUPP_CONT_DIV_CD', 'pay')
				,"FUN_PUR_USE_CD":getInfo('FUN_PUR_USE_CD', 'pay')
				,"FUN_PUR_USE_NO":getInfo('FUN_PUR_USE_NO', 'pay')
				,"BIZ_KIND_CD_1":getInfo('BIZ_KIND_CD_1', 'pay')
				,"BIZ_KIND_CD_2":getInfo('BIZ_KIND_CD_2', 'pay')
				,"BIZ_KIND_CD_3":getInfo('BIZ_KIND_CD_3', 'pay')
				,"SUPP_GOAL_CD":getInfo('SUPP_GOAL_CD', 'pay')
				,"ACCT_DATE":getInfo('ACCT_DATE', 'rede')==""?null:getInfo('ACCT_DATE', 'rede')     //접수일자
				,"LST_MODI_DATE" :getInfo('LST_MODI_DATE', 'rede')==""?null:getInfo('LST_MODI_DATE', 'rede')  //최종수정일자 
				,"JUDGE_DATE" :getInfo('JUDGE_DATE', 'rede')==""?null:getInfo('JUDGE_DATE', 'rede')     //심사일자 
				,"PAY_COMPL_DATE":getInfo('PAY_COMPL_DATE', 'pay')==""?null:getInfo('REDE_COMPL_DATE', 'rede') //지금완료일자 
				,"REDE_COMPL_DATE" :getInfo('REDE_COMPL_DATE', 'rede')==""?null:getInfo('REDE_COMPL_DATE', 'rede') //환수완료일자 
				,"PAY_REQ_NO":getInfo('PAY_REQ_NO', 'pay')    
				,"TSK_NM":tskNm
				,"BIZ_CD":bizCd
				,"IO_DIV_CD":"O" //심사내역 내외구분코드
				,"REDE_SCH_DATE":null //환수예정일시 (사용안함)
				,"CF_DATE":getInfo('CF_DATE', 'rede')    //지출결의일자
				,"ERP_SEND_YN":getInfo('ERP_SEND_YN', 'rede')  //ERP전송여부
				,"ERP_SEND_DATE":getInfo('ERP_SEND_DATE', 'rede')==""?null:getInfo('ERP_SEND_DATE', 'rede')  //ERP전송일시
				,"ERP_SEND_USERID":getInfo('ERP_SEND_USERID', 'rede')  //ERP 전송유저ID
				,"ERP_IF_NO":getInfo('ERP_IF_NO', 'rede')
				,"TSK_OP_YN":getInfo('TSK_OP_YN', 'pay')  //과제운영여부
				,"REDE_TP_CD":getInfo('REDE_TP_CD', 'rede')  //환수유형
				,"SUB_YN":getInfo('SUB_YN', 'rede') //제출여부 
				,"FILE_ID":fileId  
				,"CLO_YN":getInfo('CLO_YN', 'rede')   //환수종결여부
				,"CLO_DATE":getInfo('CLO_DATE', 'rede')==""?null:getInfo('CLO_DATE', 'rede') //환수종결일시 
				,"REG_USERID":regUserId
				,"FILE_INFO_LIST":fileInfoUploadList
				//,"FILE_INFO_DEL_LIST":fileInfoDeleteList
				//@ts-ignore 
				,"REDE_AMT_LIST":redeReqAmtListPopSaveData.data
	
			}
			
			console.log("param : "+JSON.stringify(param));
			

			//환수정보 저장 
			redeUpdate(param);
		   

		}
	}, [fileInfoUploadList])

	React.useEffect(() => {
		
			if(receivedData != undefined){
					
				let vRedeReqNo = StringUtil.defaultString(receivedData.vREDE_REQ_NO);
				let vPayReqNo = StringUtil.defaultString(receivedData.vPAY_REQ_NO);
				let vTskReqNo = StringUtil.defaultString(receivedData.vTSK_REQ_NO);
				let vTskReqModiSeq = StringUtil.defaultString(receivedData.vTSK_REQ_MODI_SEQ);

				setRedeReqNo(vRedeReqNo);
				setPayReqNo(vPayReqNo);
				setTskReqNo(vTskReqNo);
				setTskReqModiSeq(vTskReqModiSeq);
				
				initCall(vRedeReqNo, vPayReqNo,vTskReqNo,vTskReqModiSeq).then();
			}
			
			return () => {
				// @ts-ignore
				IBSheet.disposeAll(true);
			}
	}, [])//effect
	
	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={2} lnbIdx={4}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">환수신청 정보수정</h1>
					<section className="fund-section">
						<div className="hz-root hz-gap15 mb15">
							<h3 className="section-title hz-item">집행 과제</h3>
							<p className="tx-msg"><span className="fc-pri">(* &nbsp;필수 입력)</span></p>
						</div>
						<div className="fo fo-col2">
							<div className="inner">
								<div className="fo-item req">
									<p className="fo-key">과제번호</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<UIInput className={'tf tf-md hz-item hz-fg'} value={StringUtil.tskReqNoFormat(tskReqNo)}  valueChanged={(value) => setTskReqNo(value)} placeholder={''} readOnly={true}/>
											{/* <Button color='gray-o' size="md" onClick={modal2135Open}>집행과제선택</Button>  */}
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">지급신청번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'}value={StringUtil.payNoFormat(payReqNo)} valueChanged={(value) => setPayReqNo(value)}  placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">과제명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={tskNm} valueChanged={(value) => setTskNm(value)}  placeholder={''} readOnly={true} />
									</div>
								</div>
							</div>
						</div>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">환수신청</h3>
						<div className="fo fo-col2">
							<div className="inner">
								<div className="fo-item fo-m-1-3 req">
									<div className="fo-key">환수신청일</div>
									<div className="fo-value">
										<div className="w215">
											<UIDatePicker value={redeReqDate} valueChanged={(value) => setRedeReqDate(value)}/>
										</div>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<div className="fo-key">환수사유</div>
									<div className="fo-value">
										<div className="ta-group w100p">
											<UITextArea className={'ta-ip'}  value={redeReason} valueChanged={(value) => {setRedeReason(value)}} />
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title hz-item">환수기업 및 환수금액 입력<span className="fc-pri">*</span></h3>
							<div className="hz-root hz-gap8">
								<Button color='gray-o' size="sm" onClick={modal2138Open}>환수기업 내역등록</Button> 
							</div>
						</div>
						<div className="fo fo-col2">
							<UI.If test={redeAmt > 0}>
							<div className="inner">
								<div className="fo-item">
									<div className="fo-key">환수금액 합계</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={redeAmt} valueChanged={(value) => setRedeAmt(value)} placeholder={''} readOnly={true}/>
													<span className="u">원</span>
											</div>
											<div className="hz-item tx-msg">
												<span className="fc-pri">
												  ({StringUtil.isNotEmpty(redeAmt + "") ?
													StringUtil.numberToKorean(Number(redeAmt)) + " 원" : "원"})
											   </span>
											</div>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">환수기업수(개사)</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 ">
											<UIInput className={'tf tf-md ta-right hz-item hz-fg'} value={redeCorpCnt} placeholder={''} readOnly={true}/>	
											<p className="tx-msg hz-item">개사</p>
										</div>
									</div>
								</div>
							</div>
							</UI.If>
							<UI.If test={redeAmt == 0}>
							{/* NO-data */}
							<div className="nd">
								{/* <i className="ic"></i> */}
								<p className="tx tx-cp2 fc-666">환수기업 내역 등록을 선택하시고 환수기업 및 환수금액을 입력해 주세요.</p>
							</div>
							</UI.If>
						</div>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-gap15 mb15">
							<h3 className="section-title hz-item">첨부파일</h3>
							<p className="tx-msg"><span className="fc-pri">※ 환수와 관련된 각종 서류들을 첨부해주세요.</span></p>
						</div>
						<div className="inner">
							<div className="fo-item">

								<UI.FileUpload
								    value={deferredFileValue}
									onCreationComplete={onCreationComplete}
									onUploadComplete={onUploadComplete}
									attrs={{
										ImgPreView: "1", 
										Views: "thumbs",
									}}
								/>
							</div>
						</div>
						
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">기업 정보</h3>
						<div className="fo fo-col2">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} valueChanged={(value) => setCorpNm(value)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
									   <UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(corpRegNo)} valueChanged={(value) => setCorpRegNo(value)} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(bizNo)} valueChanged={(value) => setBizNo(value)} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										<div className="sl sl-md">
											<UISelect
												codeData={codeDataStore.get("potal.personByBizNo,"+bizNo)}
												firstName={"sel"}
												value={redeReqUserid}
												valueChanged={(value) => {
													if (StringUtil.isNotEmpty(value)) {
														setRedeReqUserid(value);
														setTimeout(()=>readPerson(value), 500); //담당자정보 변경 
													}
												}}
											/>
										</div>	
									
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직급</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={posiNm} valueChanged={(value) => setPosiNm(value)} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'}  value={deptNm} valueChanged={(value) => setDeptNm(value)} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'}  value={emailAdres} valueChanged={(value) => setEmailAdres(value)} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={ofcTelNo} valueChanged={(value) => setOfcTelNo(value)} placeholder={''} readOnly={true}/>
									</div>
								</div>
							</div>
						</div>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="gray-o" size="md" onClick={redeUpdateCancel}>취소</Button>
						<Button color="pri" size="md" onClick={redeFormCheck}>저장</Button>
						<Button color="gray-o" size="md" onClick={goList}>목록</Button>
					</div>
				</main>
			</div>
			
			{/* modal - 환수기업 내역등록 */}
			<ModalPopup
				open={modaladm2138Open}
				title="환수기업 내역등록"
				size="lg"
				onClose={() => modaladm2138Close()}
				onAfterOpen={() => onAfterModaladm2138Open()}
			   >
				<div className="modal-con">
					<div className="fo fo-col2 mb30">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">지원 금액 합계(원)</p>
								<div className="fo-value">
									<div className="tf-unit hz-item w100p">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(payAmtSum)} valueChanged={(value) => setPayAmtSum(value)} placeholder={''} readOnly={true}/>
										<span className="u">원</span>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">환수금액 합계(원)</p>
								<div className="fo-value">
									<div className="tf-unit hz-item w100p">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(redeAmtSum)} valueChanged={(value) => setRedeAmtSum(value)} placeholder={''} readOnly={true}/>
										<span className="u">원</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{totalReqAmtListCnt}</em>건</p>
						</div>
					
					</div>
					
					<div className="ibsheet" id='RedeReqAmtListDiv'>
						<p style={{height:"300px"}}>[D] IBSHEET 영역</p>
					</div>
					<div id="pageNaviRede" className="pg"></div>
				</div> 
				<div className="modal-bottom">
					<Button color="gray-o" size="md" onClick={modaladm2138Close}>취소</Button>
					<Button color="pri" size="md" id='modaladm2138Save' onClick={modaladm2138Save}>저장</Button>
				</div>
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;